export default __webpack_public_path__ + "static/media/fishing.df210d5c.jpg";